import React from "react";

const BankTable = ({ bankList, setBankList, disabled }) => {
  const handleAddBank = () => {
    const newBank = {
      bank_name: "",
      bank_acc_no: "",
      bank_acc_name: "",
      bank_default: "N",
    };
    setBankList((prev) => [...prev, newBank]);
  };

  const handleRemoveBank = (index) => {
    setBankList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChangeBank = (index, field, value) => {
    setBankList((prev) => {
      let updated = [...prev];
      if (field === "bank_default" && value === "Y") {
        updated = updated.map((bank, i) => ({
          ...bank,
          bank_default: i === index ? "Y" : "N",
        }));
      } else {
        updated[index][field] = value;
      }
      return updated;
    });
  };

  return (
    <div className="col-12 mt-4">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">บัญชีธนาคาร</h4>
          <button
            className="btn btn-lg  shadow text-white"
            style={{
              // marginLeft: "20px",
              backgroundColor: "#EF6C00",
              // fontSize: "16px",
            }}
            type="button"
            onClick={handleAddBank}
            disabled={disabled}
          >
            <i className="fa fa-plus"></i> เพิ่มบัญชี
          </button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center">ธนาคาร</th>
                  <th className="text-center">เลขบัญชี</th>
                  <th className="text-center">ชื่อบัญชี</th>
                  <th className="text-center">บัญชีหลัก</th>
                  <th className="text-center">ลบ</th>
                </tr>
              </thead>
              <tbody>
                {bankList.length > 0 ? (
                  bankList.map((bank, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        <input
                          className="form-control"
                          value={bank.bank_name}
                          onChange={(e) =>
                            handleChangeBank(index, "bank_name", e.target.value)
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={bank.bank_acc_no}
                          onChange={(e) =>
                            handleChangeBank(
                              index,
                              "bank_acc_no",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          value={bank.bank_acc_name}
                          onChange={(e) =>
                            handleChangeBank(
                              index,
                              "bank_acc_name",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        />
                      </td>
                      <td>
                        <select
                          className="form-select"
                          value={bank.bank_default}
                          onChange={(e) =>
                            handleChangeBank(
                              index,
                              "bank_default",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        >
                          <option value="Y">ใช่</option>
                          <option value="N">ไม่ใช่</option>
                        </select>
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleRemoveBank(index)}
                          disabled={disabled}
                          type="button"
                        >
                          ลบ
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <center>ไม่พบข้อมูลบัญชี</center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankTable;
